import { create } from 'zustand'
import { QUESTION_STATE_SCENARIOS } from '../constants/appConstants';

export const useQuestionStore = create((set, get) => ({
  questionState: {['0']: {answerState: QUESTION_STATE_SCENARIOS.NOT_STARTED, voteSubmitted: false, started: false}},
  updateAnswerState: (qId, currentQState) => set((state) => {
    console.log("updateQuestionState2", qId, currentQState);
    const tempState = {...state.questionState};
    tempState[qId]['answerState'] = currentQState
    return {questionState: tempState}
  }),
  updateSubmitState: (qId, voteSubmitted) => set((state) => {
    const tempState = {...state.questionState};
    tempState[qId]['voteSubmitted'] = voteSubmitted
    return {questionState: tempState}
  }),
  updateStartState: (qId, started) => set((state) => {
    const tempState = {...state.questionState};
    tempState[qId]['started'] = started
    return {questionState: tempState}
  })
}))